module.exports = __webpack_public_path__ + "img/create-filter-categories.e1090eaf.png";